import React, { FC } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import classes from "./Loading.module.scss";
import { loadingState, loadingText } from "../../../states/loadingState";
import { useRecoilValue } from "recoil";
import { theme } from "../../../theme/theme";
import { userState } from "../../../states/userState";
interface LoadingProps {
  children: React.ReactNode;
}

const Loading: FC<LoadingProps> = ({ children }) => {
  const isBeingLoaded = useRecoilValue(loadingState);
  const displayText = useRecoilValue(loadingText);
  const user = useRecoilValue(userState);
  return (
    <>
      {isBeingLoaded && (
        <section className={classes.section__loading}>
          <CircularProgress sx={color(user?.mode ?? "lite")} />
          {/* <ReactLoading type={"spin"} color="#0adcc0" /> */}
          <p>{displayText}</p>
        </section>
      )}
      {children}
    </>
  );
};
const color = (mode: string) => {
  return {
    color:
      mode === "lite"
        ? theme.palette.liteColor.foreColor.main //間違いではない。色合いを考慮してdarkColorを指定している
        : theme.palette.darkColor.foreColor.main,
  };
};

export default Loading;
